// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1d49702d","453":"55ba3a4c","667":"d7ac3420","977":"7660bf55"}[chunkId] + ".chunk.js";
};